// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import 'src/tokens/index.css';*/
/*@import 'src/tokens/spacing.css';*/
/*@import 'src/tokens/shapes.css';*/
/*@import 'src/tokens/typography.css';*/


:host {
    --margin-right: 1px;
    /*min-width: 100%;*/
    color: var(--text-light);
}

/*  ============================================================================
    tab
    ==========================================================================*/
[role="tab"] {
    background-color: var(--background-white);
    background: transparent;
    box-sizing: border-box;
    color: var(--text-light);
    font-family: var(--font-family);
    font-size: var(--p2-medium-font-size);
    height: var(--spacing-50);
    padding: 0 var(--spacing-20);
    border: none;
    /*swift.com does not has border bottom in unselected tabs*/
    /*border-bottom: 1px solid var(--border-light);*/
    outline: none;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    z-index: 1;
}
[role="tab"]:hover {
    color: var(--accent-strong-default);
}
[role="tab"]:focus-visible {
    color: var(--accent-strong-default);
    outline: 1px solid var(--border-focused);
    margin-right: var(--margin-right);
    padding-right: calc(var(--spacing-20) - var(--margin-right));
}
[role="tab"][aria-selected="true"] {
    /*design system 2px*/
    border-bottom: 4px solid var(--border-focused);
    z-index: 1;
    cursor: default;
}

/*  ============================================================================
    tabpanel
    ==========================================================================*/
[role="tabpanel"] {
    background-color: var(--background-white);
    background: var(--background-white);
    font-family: var(--font-family);
    margin: 0;
    padding: var(--spacing-20);
}
[role="tabpanel"].is-hidden {
    display: none;
}


:host([visibility="mobile"]) {
    display: none;
}

@media (max-width: 940px) {
    :host([visibility="desktop"]) {
        display: none;
    }
    :host([visibility="mobile"]) {
        display: block;
    }
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/tabs/style/index.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC,oCAAoC;AACpC,mCAAmC;AACnC,uCAAuC;;;AAGvC;IACI,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;;+EAE+E;AAC/E;IACI,yCAAyC;IACzC,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;IACxB,+BAA+B;IAC/B,qCAAqC;IACrC,yBAAyB;IACzB,4BAA4B;IAC5B,YAAY;IACZ,0DAA0D;IAC1D,gDAAgD;IAChD,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,iCAAiC;IACjC,4DAA4D;AAChE;AACA;IACI,oBAAoB;IACpB,8CAA8C;IAC9C,UAAU;IACV,eAAe;AACnB;;AAEA;;+EAE+E;AAC/E;IACI,yCAAyC;IACzC,mCAAmC;IACnC,+BAA+B;IAC/B,SAAS;IACT,0BAA0B;AAC9B;AACA;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":["/*@import 'src/tokens/index.css';*/\n/*@import 'src/tokens/spacing.css';*/\n/*@import 'src/tokens/shapes.css';*/\n/*@import 'src/tokens/typography.css';*/\n\n\n:host {\n    --margin-right: 1px;\n    /*min-width: 100%;*/\n    color: var(--text-light);\n}\n\n/*  ============================================================================\n    tab\n    ==========================================================================*/\n[role=\"tab\"] {\n    background-color: var(--background-white);\n    background: transparent;\n    box-sizing: border-box;\n    color: var(--text-light);\n    font-family: var(--font-family);\n    font-size: var(--p2-medium-font-size);\n    height: var(--spacing-50);\n    padding: 0 var(--spacing-20);\n    border: none;\n    /*swift.com does not has border bottom in unselected tabs*/\n    /*border-bottom: 1px solid var(--border-light);*/\n    outline: none;\n    cursor: pointer;\n    overflow: hidden;\n    position: relative;\n    z-index: 1;\n}\n[role=\"tab\"]:hover {\n    color: var(--accent-strong-default);\n}\n[role=\"tab\"]:focus-visible {\n    color: var(--accent-strong-default);\n    outline: 1px solid var(--border-focused);\n    margin-right: var(--margin-right);\n    padding-right: calc(var(--spacing-20) - var(--margin-right));\n}\n[role=\"tab\"][aria-selected=\"true\"] {\n    /*design system 2px*/\n    border-bottom: 4px solid var(--border-focused);\n    z-index: 1;\n    cursor: default;\n}\n\n/*  ============================================================================\n    tabpanel\n    ==========================================================================*/\n[role=\"tabpanel\"] {\n    background-color: var(--background-white);\n    background: var(--background-white);\n    font-family: var(--font-family);\n    margin: 0;\n    padding: var(--spacing-20);\n}\n[role=\"tabpanel\"].is-hidden {\n    display: none;\n}\n\n\n:host([visibility=\"mobile\"]) {\n    display: none;\n}\n\n@media (max-width: 940px) {\n    :host([visibility=\"desktop\"]) {\n        display: none;\n    }\n    :host([visibility=\"mobile\"]) {\n        display: block;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
